import {
  HttpClient,
  HttpContext,
  HttpErrorResponse,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AxiosRequestConfig } from 'axios';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { USE_CORRELATION_ID } from '@nibtravel/shared/util/constants';

import {
  AdpterResponse,
  CustomAdapter,
  GenericReponse,
} from './models/axios.types';

@Injectable({ providedIn: 'root' })
export class NibtravelAxiosAdapterService {
  constructor(private http: HttpClient) {}

  adapter: CustomAdapter = (config: AxiosRequestConfig): AdpterResponse =>
    this.apiRequest(config);

  private async apiRequest(
    config: AxiosRequestConfig
  ): Promise<GenericReponse> {
    const { url, headers, data, params, baseURL } = config;
    const request = this.http.request<Record<string, unknown>>(
      config.method?.toUpperCase() || 'GET',
      `${baseURL}/${url}`,
      {
        body: data,
        headers: new HttpHeaders(headers),
        params,
        observe: 'response',
        context: new HttpContext().set(USE_CORRELATION_ID, false),
      }
    );

    return await request
      .pipe(map((response) => this.mapResponse(response, config, request)))
      .toPromise();
  }

  private mapResponse(
    response: HttpResponse<Record<string, unknown>>,
    config: AxiosRequestConfig,
    request: Observable<HttpResponse<Record<string, unknown>>>
  ): GenericReponse {
    return {
      data: this.responseIsError(response) ? response.error : response.body,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      config: config,
      request: request,
    };
  }

  private responseIsError(
    response: HttpResponse<Record<string, unknown>> | HttpErrorResponse
  ): response is HttpErrorResponse {
    return response instanceof HttpErrorResponse;
  }
}
